import React, { useMemo } from 'react';
import styles from './index.module.scss';
import { Pie } from 'react-chartjs-2';

const chartConfig = {
  colorConfig: {
    backgroundColor: [
      '#E74C3C',
      '#9B59B6',
      '#2980B9',
      '#F39C12',
      '#1ABC9C',
    ],
    hoverBackgroundColor: [
      '#F1948A',
      '#C39BD3',
      '#7FB3D5',
      '#F8C471',
      '#76D7C4',
    ],
  },
  chartOptions: {
    maintainAspectRatio: false,
    plugins: {
      title: {
        display: false,
        text: 'Orders Grouped According Source',
        fontSize: 25,
        align: 'start' as 'start',
      },
      legend: {
        display: true,
        position: 'left' as 'left',
      },
    },
  },
};

const ORDER_SOURCE_MAPPING = {
  WEB_APP: 'WEB APP',
  HOMEBOX: 'HOMEBOX',
  EXTERNAL_ORDER: 'EXTERNAL ORDER',
  MOBILE_APP: 'MOBILE APP',
};

const PieChart = props => useMemo(() => {
  const { data, pivot }= props;
  const getDataProperty = (propertyName: string) => data.map(record => record[propertyName]);
  const getOrderSourceDisplayValue = (sourceKeys: string[]) => sourceKeys.map(key => ORDER_SOURCE_MAPPING[key]);

  const chartData = {
    labels: getOrderSourceDisplayValue(getDataProperty('orderSource')),
    datasets: [
      {
        ...chartConfig.colorConfig,
        data: getDataProperty(pivot),
      },
    ],
  };

  return (
    <div className={styles['pie-chart-container']}>
      <Pie
        width={475}
        height={475}
        data={chartData}
        options={chartConfig.chartOptions}
      />
    </div>
  );
}, [props.data, props.pivot]);

export default PieChart;